import { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import './index.css';
import { AuthProvider, useAuth } from '@/context/AuthContext';
import { observability, queryClient } from '@/config/queryClient';
import { router } from '@/router';
import { QueryClientProvider } from '@tanstack/react-query';
import {
  ObservabilityProvider,
  instrumentRouter,
} from '@/observability';

instrumentRouter(router, observability);

const QueryDevtools = import.meta.env.DEV
  ? lazy(() => import('@/components/QueryDevtools').then((module) => ({ default: module.QueryDevtools })))
  : null;

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

function InnerApp() {
  const auth = useAuth();

  if (auth.loading) {
    return (
      <div className="loading-container">
        <div className="spinner" />
        <p className="loading-text">Carregando...</p>
      </div>
    );
  }

  return (
    <RouterProvider
      router={router}
      context={{ auth }}
    />
  );
}

createRoot(container).render(
  <ObservabilityProvider value={observability}>
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <InnerApp />
        {QueryDevtools ? (
          <Suspense fallback={null}>
            <QueryDevtools />
          </Suspense>
        ) : null}
      </QueryClientProvider>
    </AuthProvider>
  </ObservabilityProvider>,
);
